<template>
  <div class="page-content-container">
    <div class="title-container mb-4">
      <h4 class="page-title">Generated Reports</h4>
      <p class="text-muted">
        List of background jobs of reports generation
      </p>
    </div>
    <div class="table-container">
      <div
          v-if="isLoadingJobs"
          class="d-flex align-items-center justify-content-center gap-3 p-3 font-500"
      >
        <b-spinner></b-spinner> Loading...
      </div>
      <table v-else-if="jobs && jobs.length > 0" class="table table-hover table-borderless payments-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Job ID</th>
            <th>Job Type</th>
            <th>Status</th>
            <th>Date</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody v-if="jobs && jobs.length > 0">
          <tr
              v-for="(job, index) in jobs"
              :key="job.id"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ job.id }}</td>
            <td>{{ generateJobTitle(job) }}</td>
            <td>
              <div
                  :class="[
                    'status-tag',
                    {
                      warning: job.state.status.toLowerCase() === 'queued' || job.state.status.toLowerCase() === 'processing',
                      success: job.state.status.toLowerCase() === 'succeeded',
                      danger: job.state.status.toLowerCase() === 'failed'
                    },
                  ]"
              >
                {{ job.state.status }}
              </div>
            </td>
            <td>{{ formatDate(job.queuedAt) }}</td>
            <td>
              <div>
                <b-dropdown size="sm" :id="`dropdown-${job.id}`" text="Actions" class="m-md-2" variant="outline-primary">
                  <b-dropdown-item v-for="action in getJobActionMenu(job.type)" @click="onJobActionPerformed(job, action)">{{ action }}</b-dropdown-item>
                </b-dropdown>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 v-else>
        No jobs found.
      </h5>
    </div>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import {formatToDDMMMYY_HHmm} from "../../helpers/FormatHelpers";
import router from "@/router";

export default {
  name: "GeneratedReports",
  components: {

  },
  data() {
    return {
      isLoadingJobs: false,
      jobs: [],
      activeActionMenus: []
    };
  },
  async created() {
    try {
      this.isLoadingJobs = true;
      this.jobs = await this.fetchReportingJobs();
    } catch (error) {
      console.error(error)
    } finally {
      this.isLoadingJobs = false;
    }
  },
  methods: {
    ...mapActions("backgroundJobs", ["fetchReportingJobs"]),
    formatDate(date) {
      return formatToDDMMMYY_HHmm(date);
    },
    generateJobTitle(job) {
      switch(job.type.toLowerCase()) {
        case 'useractivityreportgeneration':
          return `User Content Activity Report for Batch ID: ${job.referenceKey}`;
        default:
          return job.type;
      }
    },
    getJobActionMenu(jobType) {
      switch(jobType.toLowerCase()) {
        case 'useractivityreportgeneration':
          return ["Download"];
        default:
          return [];
      }
    },
    onJobActionPerformed(job, action) {
      switch(`${job.type.toLowerCase()}.${action.toLowerCase()}`) {
        case 'useractivityreportgeneration.download':
          this.downloadUserActivityReport(job);
          break;
        default:
          break;
      }
    },
    async downloadUserActivityReport(job) {
      const outputData = JSON.parse(job.outputData);

      if(outputData) {
        const fileUrl = outputData.fileUrl;
        const filePassword = outputData.filePassword;

        const response = await fetch(fileUrl);

        if (!response.ok) {
          this.$toasted.error(
              `Error while downloading file (${response.status})`,
              {
                theme: "outline",
                position: "bottom-center",
                duration: 3000,
              }
          );

          throw new Error(`Download failed: ${response.status}`);
        }

        const blob = await response.blob();

        const filename = fileUrl.split("/").pop().split("?")[0] || "download";

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();

        URL.revokeObjectURL(link.href);

        let isPasswordCopiedToClipboard = false;

        try {
          await navigator.clipboard.writeText(filePassword);
          isPasswordCopiedToClipboard = true;
        } catch (err) {
          isPasswordCopiedToClipboard = false;
          console.error('Failed to copy text: ', err);
        }

        this.$toasted.success(isPasswordCopiedToClipboard ? "File downloaded and password has been copied to your clipboard." : "File downloaded!", {
          theme: "outline",
          position: "bottom-center",
          duration: null,
          icon: {
            iconPack: 'fontawesome',
            name: 'fa-check',     // The icon name
          },
          action: [
            {
              text: 'View password',
              onClick: (e, toastObject) => {
                this.$toasted.success(`Password: ${filePassword}`, {
                  theme: "outline",
                  position: "bottom-center",
                  duration: null,
                  action: [
                    {
                      text: 'Copy',
                      onClick: async (e2, toastObject2) => {
                        try {
                          await navigator.clipboard.writeText(filePassword);
                          toastObject2.goAway(0);
                        } catch (err) {
                          this.$toasted.error('Error while copying password to clipboard. Please type the password manually.', {
                            theme: "outline",
                            position: "bottom-center",
                            duration: 5000,
                          });
                        }
                      }
                    }
                  ]
                });
                toastObject.goAway(0);
              }
            },
            {
              text: 'Dismiss',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              }
            }
          ]
        });
      }
    }
  },
  computed: {

  }
}
</script>

<style scoped>
.page-content-container {
  background-color: #f5f5f5;
  height: calc(100vh - 5rem);
  padding: 1.875rem;
  overflow-y: auto;
}

.table-container {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 3px 6px #d5d5d529;
}
.payments-table thead tr,
.payments-table td {
  height: 4rem;
  vertical-align: middle;
}
</style>